import reduceColorPointByStep from '../../../../../common/utils/reduce-color-point-by-step';

const dark = (params) => {
  const { targetColor, targetColorPalette } = params;
  const fallback = {
    rule: 'filePicker.button.background.hover.dark',
    params,
  };
  if (targetColor.equals(targetColorPalette[50])) {
    return targetColorPalette[100];
  }

  const reducedColor = reduceColorPointByStep({
    targetColor,
    targetColorPalette,
    step: 1,
    fallback,
  });

  return reducedColor;
};

export default dark;
